import { numericFormatter } from "react-number-format";
export const buildLabelMortgageContract = (c) => {
  return `${c.contractId} - ${c.bankName}- ${numericFormatter(`${c.firstDebt || 0}`, {
    thousandsGroupStyle: "thousand",
    thousandSeparator: ",",
    decimalScale: c.currency === 'VND' ? 2 : 4,
    suffix: c.currency === 'VND' ? 'đ' : '',
    prefix: c.currency === 'USD' ? '$' : '',
  })}`
}